module.exports = __webpack_public_path__ + "img/warning-blue.d8b72487.png";